import React from "react";
import PropTypes from "prop-types";
import { Header as SimanticHeader } from "semantic-ui-react";
import cx from "classnames";
import styles from "./styles.less";

const Header = ({
  text,
  textBold,
  isRtl,
  className,
  subtitle,
  isMobileView,
  noSidePadding,
  lightBottomPadding,
  noPadding
}) => {
  return (
    <div
      className={cx(styles.wrapper, {
        [styles.mobileView]: isMobileView,
        [styles.subtitleText]: subtitle,
        [styles.noSidePadding]: noSidePadding,
        [styles.lightBottomPadding]: lightBottomPadding,
        [styles.noPadding]: noPadding
      })}
    >
      <SimanticHeader
        className={cx(styles.headerText, className, {
          [styles.rtl]: isRtl
        })}
        as="h2"
        inverted
        content={text}
      />
      {textBold && (
        <SimanticHeader
          className={cx(styles.headerText, styles.bold, className, {
            [styles.rtl]: isRtl
          })}
          as="h2"
          inverted
          content={textBold}
        />
      )}
    </div>
  );
};

Header.defaultProps = {
  isRtl: false,
  text: "No header text entered.",
  subtitle: false,
  isMobileView: false,
  noSidePadding: false,
  noPadding: false
};

Header.propTypes = {
  isRtl: PropTypes.bool,
  text: PropTypes.string,
  textBold: PropTypes.string,
  className: PropTypes.string,
  subtitle: PropTypes.bool,
  isMobileView: PropTypes.bool,
  noSidePadding: PropTypes.bool,
  noPadding: PropTypes.bool,
  lightBottomPadding: PropTypes.bool
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/common/Header/Header.js